// extracted by mini-css-extract-plugin
export var message = "banners-module--message--c7ad4";